/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CosmosTabs as CosmosTabsRoot } from "./CosmosTabs";
import { CosmosTabsButtonList } from "./CosmosTabsButtonList";
import { CosmosTabsButton } from "./CosmosTabsButton";
import { CosmosTabsPanel } from "./CosmosTabsPanel";

import type { CosmosTabsProps } from "./CosmosTabs";
import type { CosmosTabsButtonListProps } from "./CosmosTabsButtonList";
import type { CosmosTabsButtonProps } from "./CosmosTabsButton";
import type { CosmosTabsPanelProps } from "./CosmosTabsPanel";

const CosmosTabs: typeof CosmosTabsRoot & {
	ButtonList: typeof CosmosTabsButtonList;
	Button: typeof CosmosTabsButton;
	Panel: typeof CosmosTabsPanel;
} = Object.assign(CosmosTabsRoot, {
	ButtonList: CosmosTabsButtonList,
	Button: CosmosTabsButton,
	Panel: CosmosTabsPanel,
});

export { CosmosTabs, CosmosTabsButtonList, CosmosTabsButton, CosmosTabsPanel };

export type { CosmosTabsProps, CosmosTabsButtonListProps, CosmosTabsButtonProps, CosmosTabsPanelProps };

export { useTabsContext } from "./tabs.context";
export type { TabsContextValue } from "./tabs.context";

export { useTabActiveIndex } from "./tabs.hooks";
